module.exports = __webpack_public_path__ + "img/site-empty.e25d5364.png";